import { ExpandableStepProps, WintFormData } from "models/propTypes/wintFormPropsTypes";

function useWintExpandableStep(form: WintFormData<any>): ExpandableStepProps {
  return {
    submitCount: form.submitCount,
    isSubmitting: form.isSubmitting,
  };
}

export default useWintExpandableStep;
